import axios from "axios";
import React, { useState, useEffect, Component } from 'react'
import { Button, Col, Container, ListGroup, Row, Badge, Modal, Form, FormGroup, FormLabel, Card, Table } from "react-bootstrap";
import { Navigate} from 'react-router-dom';
import CurrencyInput,{ formatValue } from 'react-currency-input-field';
import {connect} from 'react-redux';
import {getAssets, createAsset, updateAsset, deleteAsset, createTransaction} from '../context/actions/index';
import { DatabaseAdd } from 'react-bootstrap-icons';
import { 
    FaPlus,
  FaDownload, 
  FaPrint, 
  FaFilter,
  FaEye,
  FaEyeSlash,
  FaChartLine,
  FaBuilding,
  FaMoneyBillWave,
  FaCreditCard,
  FaPiggyBank,
  FaHome,
  FaChartPie
} from 'react-icons/fa';

import CreateAssetForm from "./CreateAssetForm"
//import {CreateAssetForm} from './createAsset'

class Assets extends Component{
    handleClose = () => this.setState({data:'', show:false, edit:false});
    handleShow = () => {
        const today = new Date()
        const active_month = new Date(this.props.books["active_month"])
        /*
console.log(today.getUTCMonth())
console.log(active_month.getUTCMonth())
console.log(today.getUTCFullYear())
console.log(active_month.getUTCFullYear())
*/
        //tst hide
        
        if((today.getUTCMonth()!==active_month.getUTCMonth())||today.getUTCFullYear()!==active_month.getUTCFullYear()){
            alert("tidak bisa ubah aset, silahkan ganti bulan buku")
            if(window.confirm("ganti dengan bulan sekarang?")){
                this.setState({redirect:true})
            }
        }else{
           this.setState({show:true, });
        }
           
        ///test
        //this.setState({show:true, });
        //end test
        
    }
    //navigate = useNavigate()
    constructor(props){
        super(props);
		this.state ={
			show: false,
            data:'',
            edit:false,
            showCloseBookConfirm: false,
            closeBookLoading: false, 
            assets:[]
		}
    }
    componentDidMount(){
        /*
        if(typeof localStorage.bookId!=="undefined"){
            var bookId = JSON.parse(localStorage.bookId);
        }
        */
        //this.props.getAssets(bookId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    // Fungsi untuk menghitung total asset dengan menambahkan transaksi
    calculateAssetWithTransactions = (assets, transactions) => {
        return assets.map(asset => {
            // Filter transaksi yang terkait dengan asset ini
            const assetTransactions = transactions.filter(transaction => 
                transaction.asset_id === asset.asset_id
            );

            // Hitung total dari transaksi
            const transactionTotal = assetTransactions.reduce((total, transaction) => {
                let amount = parseInt(transaction.amount) || 0;
                
                /*
                // Jika transaksi adalah transfer masuk ke asset ini
                if (transaction.to_asset_id === asset.asset_id) {
                    return total + Math.abs(amount);
                }
                // Jika transaksi adalah transfer keluar dari asset ini
                else if (transaction.asset_id === asset.asset_id && transaction.reff_id) {
                    return total - Math.abs(amount);
                }
                // Jika transaksi biasa (bukan transfer)
                else if (transaction.asset_id === asset.asset_id && !transaction.reff_id) {
                    // Untuk aset (type 1), pendapatan menambah, pengeluaran mengurangi
                    if (asset.type === '1') {
                        return total + amount;
                    }
                    // Untuk kewajiban (type 2), pendapatan mengurangi, pengeluaran menambah
                    else if (asset.type === '2') {
                        return total - amount;
                    }
                }
                    */
                
                return total + amount;
            }, 0);

            // Jumlahkan dengan amount awal asset
            const initialAmount = parseInt(asset.amount) || 0;
            const finalAmount = initialAmount + transactionTotal;

            return {
                ...asset,
                initialAmount: initialAmount,
                transactionTotal: transactionTotal,
                finalAmount: finalAmount,
                transactionCount: assetTransactions.length
            };
        });
    };

    calculateTotal = (items) => {
        let total = 0;
        items.forEach(item => {
            const amount = parseInt(item.finalAmount || item.amount);
            total += amount;
        })
        //console.log(total) 
        return total;
    };

    editData =(data)=>{
        const active_month = new Date(this.props.books["active_month"])
        //console.log(active_month.getMonth())
        //console.log(this.props.assets[0].month-1)
        this.setState({data:data, edit:true})
        if(!this.props.assets[0].month){
            this.handleShow()
        }else{
            alert("buku sudah ditutup, aset tidak bisa di edit")
        }
            
      // }
    }


    ListAssets = () =>{
        //console.log(this.props.assets)
        try{
        // Hitung asset dengan transaksi
        const assetsWithTransactions = this.calculateAssetWithTransactions(
            this.props.assets, 
            this.props.transactions
        );

        var asetLancar = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='1'))
        var asetGuna = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='2'))
        var asetInvestasi = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='3'))
        var kewajibanPendek = assetsWithTransactions.filter(asset => (asset.type ==='2' && asset.category ==='4'))
        var kewajibanPanjang = assetsWithTransactions.filter(asset => (asset.type ==='2' && asset.category ==='5'))

        const totalCurrentAssets = this.calculateTotal(asetLancar);
        const totalFixedAssets = this.calculateTotal(asetGuna);
        const totalInvestmentAssets = this.calculateTotal(asetInvestasi);
        const totalAssets = totalCurrentAssets + totalFixedAssets + totalInvestmentAssets;
        
        const totalCurrentLiabilities = this.calculateTotal(kewajibanPendek);
        const totalLongTermLiabilities = this.calculateTotal(kewajibanPanjang);
        const totalLiabilities = totalCurrentLiabilities + totalLongTermLiabilities;

        // Fungsi untuk render row asset dengan detail transaksi
        const renderAssetRow = (asset) => {
            const hasTransactions = asset.transactionCount > 0;
            const amountDifference = asset.finalAmount - asset.initialAmount;
            
            return (
                <tr key={asset.asset_id}  
                    onClick={(key)=>{ this.editData(asset) }}
                    className={hasTransactions ? 'asset-with-transactions' : ''}
                > 
                    <td>
                        <div className="d-flex flex-column">
                            <span>{asset.name}</span>
                            {hasTransactions && (
                                <small className="text-muted">
                                    {asset.transactionCount} transaksi • 
                                    Saldo awal: {formatValue({
                                        value: asset.initialAmount.toString(),
                                        intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                    })}
                                </small>
                            )}
                        </div>
                    </td>
                    <td className="text-end">
                        <div className="d-flex flex-column align-items-end">
                            <span className="positive-value">
                                {formatValue({
                                    value: asset.finalAmount.toString(),
                                    intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                })}
                            </span>
                            {hasTransactions && amountDifference !== 0 && (
                                <small className={amountDifference > 0 ? 'text-success' : 'text-danger'}>
                                    {amountDifference > 0 ? '+' : ''}
                                    {formatValue({
                                        value: amountDifference.toString(),
                                        intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                    })}
                                </small>
                            )}
                        </div>
                    </td>
                </tr>
            );
        };
            
        return (
            <>
                
            <Row>
                <Col md={6} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                            <h6 className="card-title text-muted">Total Aset</h6>
                            <h3 className="text-primary">{formatValue({
                                                value: totalAssets.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                                })}</h3>
                            </div>
                            <div className="bg-primary bg-opacity-10 p-3 rounded">
                            <FaBuilding className="text-primary" size={24} />
                            </div>
                        </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                            <h6 className="card-title text-muted">Total Kewajiban</h6>
                            <h3 className="text-danger">{formatValue({
                                                value: totalLiabilities.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                                })}</h3>
                            </div>
                            <div className="bg-danger bg-opacity-10 p-3 rounded">
                            <FaCreditCard className="text-danger" size={24} />
                            </div>
                        </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Info Summary */}
            <Card className="mb-4 border-0 shadow-sm bg-light">
                <Card.Body className="py-3">
                    <Row className="text-center">
                        <Col md={4}>
                            <small className="text-muted">Total Aset Awal</small>
                            <div className="fw-bold text-primary">
                                {formatValue({
                                    value: this.calculateTotal(this.props.assets.filter(a => a.type === '1')).toString(),
                                    intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                })}
                            </div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Total Transaksi Diproses</small>
                            <div className="fw-bold text-info">
                                {this.props.transactions.length} transaksi
                            </div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Selisih setelah Transaksi</small>
                            <div className="fw-bold text-success">
                                {formatValue({
                                    value: (totalAssets - this.calculateTotal(this.props.assets.filter(a => a.type === '1'))).toString(),
                                    intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                })}
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Row>
                <Col md={6} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm mb-4">
                        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">
                                <i className="fas fa-wallet me-2 text-success"></i>
                                ASET
                            </h6>
                            <Badge bg="light" text="dark">
                                {asetLancar.length + asetGuna.length + asetInvestasi.length} items
                            </Badge>
                        </Card.Header>
                        <Card.Body>
                            <h6 className="text-primary mb-3">
                                Aset Lancar
                                <Badge bg="primary" className="ms-2">
                                    {asetLancar.length}
                                </Badge>
                            </h6>
                            <Table borderless hover className="m-0">
                                <tbody>
                                    {asetLancar.map(asset => renderAssetRow(asset))}
                                    <tr className="table-primary">
                                        <td className="fw-bold">Total Aset Lancar</td>
                                        <td className="text-end fw-bold">
                                            {formatValue({
                                                value: totalCurrentAssets.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                            <h6 className="text-primary mb-3 mt-4">
                                Aset Guna
                                <Badge bg="primary" className="ms-2">
                                    {asetGuna.length}
                                </Badge>
                            </h6>
                            <Table borderless hover className="m-0">
                                <tbody>
                                    {asetGuna.map(asset => renderAssetRow(asset))}
                                    <tr className="table-primary">
                                        <td className="fw-bold">Total Aset Guna</td>
                                        <td className="text-end fw-bold">
                                            {formatValue({
                                                value: totalFixedAssets.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                    
                            <h6 className="text-primary mb-3 mt-4">
                                Aset Investasi
                                <Badge bg="primary" className="ms-2">
                                    {asetInvestasi.length}
                                </Badge>
                            </h6>
                            <Table borderless hover className="m-0">
                                <tbody>
                                    {asetInvestasi.map(asset => renderAssetRow(asset))}
                                    <tr className="table-primary">
                                        <td className="fw-bold">Total Aset Investasi</td>
                                        <td className="text-end fw-bold">
                                            {formatValue({
                                                value: totalInvestmentAssets.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                    <tr className="table-primary">
                                        <td className="fw-bold fs-5">Total Aset</td>
                                        <td className="text-end fw-bold fs-5 text-primary">
                                        {formatValue({
                                                value: totalAssets.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
                
                <Col md={6} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Header className="bg-danger text-white d-flex justify-content-between align-items-center">
                            <h6 className="m-0">
                                <i className="fas fa-file-invoice-dollar me-2 text-danger"></i>
                                KEWAJIBAN
                            </h6>
                            <Badge bg="light" text="dark">
                                {kewajibanPendek.length + kewajibanPanjang.length} items
                            </Badge>
                        </Card.Header>
                        <Card.Body>
                            <h6 className="text-danger mb-3">
                                Kewajiban Lancar
                                <Badge bg="danger" className="ms-2">
                                    {kewajibanPendek.length}
                                </Badge>
                            </h6>
                            <Table borderless className="mb-4">
                                <tbody>
                                    {kewajibanPendek.map(asset => renderAssetRow(asset))}
                                    <tr className="table-danger">
                                        <td className="fw-bold">Total kewajiban Lancar</td>
                                        <td className="text-end fw-bold">
                                            {formatValue({
                                                value: totalCurrentLiabilities.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            
                            <h6 className="text-danger mb-3">
                                Kewajiban Jangka Panjang
                                <Badge bg="danger" className="ms-2">
                                    {kewajibanPanjang.length}
                                </Badge>
                            </h6>
                            <Table borderless className="mb-4">
                                <tbody>
                                    {kewajibanPanjang.map(asset => renderAssetRow(asset))}
                                    <tr className="table-danger">
                                        <td className="fw-bold">Total Kewajiban Jangka Panjang</td>
                                        <td className="text-end fw-bold">
                                            {formatValue({
                                                value: totalLongTermLiabilities.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                    <tr className="table-danger">
                                        <td className="fw-bold fs-5">Total Kewajiban</td>
                                        <td className="text-end fw-bold fs-5 text-danger">
                                            {formatValue({
                                                value: totalLiabilities.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>                        
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            </>
        );
            }
            catch(e){
                console.log(e)
            }
    }

    CreateAssetModal = (data) =>{
        return(
        <Modal size="lg" contentClassName="form" show={this.state.show} onHide={this.handleClose}>
        <Modal.Body>
            <CreateAssetForm 
            handleClose={this.handleClose} 
            show={this.state.show} 
            data={this.state.data} 
            edit={this.state.edit} 
            createAsset={this.props.createAsset}
            updateAsset={this.props.updateAsset}
            deleteAsset={this.props.deleteAsset}
            createTransaction={this.props.createTransaction}
            />
        </Modal.Body>
      </Modal>
        )
    }

    render(){
        if(this.state.redirect){
            return <Navigate to={"/reviewbook"} />
        }
        return (
            <>
                <this.CreateAssetModal/>
                <Container className="my-5">
                    <Row className="mb-4 sub-title">
                        <Col>
                        <h2 className="d-flex align-items-center">
                            <FaChartLine className="me-2 text-primary" />
                            Laporan Neraca
                        </h2>
                        <p className="text-muted d-none d-sm-block">Informasi asset dan kewajiban anda</p>
                        </Col>
                        <Col xs="auto">
                        <Button variant="primary" className="modal-trigger-btn" onClick={this.handleShow}>
                            <FaPlus className="me-1" /> Akun
                        </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <this.ListAssets/>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

const mapStateToProps = state => {
    return{
        user : state.user,
        books: state.books,
        assets: state.assets,
        transactions: state.transactions
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getAssets: (book) => dispatch(getAssets(book)),
        createAsset: (book) => dispatch(createAsset(book)),
        updateAsset: (book) => dispatch(updateAsset(book)),
        createTransaction: (book) => dispatch(createTransaction(book)),
        deleteAsset: (book) => dispatch(deleteAsset(book)),
    }
} 
export default connect(mapStateToProps, mapDispatchToProps)(Assets);